module.exports = __webpack_public_path__ + "img/Button-2.5305bd71.png";